import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'

export function RenamedText({info}: {info: IssueEventInfo}) {
  const {previousTitle, newTitle} = info
  if (!previousTitle || !newTitle) return <>renamed</>
  return (
    <>
      changed the title from <s>{previousTitle}</s> to <strong>{newTitle}</strong>
    </>
  )
}
